import { List } from 'immutable';
import { useContext, useState } from 'react';
import { useGetOperators } from './useGetOperators';
import { usePropertyFilterOnChangeHandler } from './usePropertyFilterOnChangeHandler';
import { useStrategy } from './useStrategy';
import { utils } from './useEditorActions';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
import { useValidateCondition } from './useValidateCondition';
import { And, Or } from '../filterQueryFormat/logic/FilterLogicGroup';
export const unwrapCondition = logicGroupInstance => {
  var _logicGroupInstance$c, _outerCondition$condi, _outerCondition$condi2;
  // @ts-expect-error the types are bad but optinoal chaining makes this safe
  const outerCondition = logicGroupInstance === null || logicGroupInstance === void 0 || (_logicGroupInstance$c = logicGroupInstance.conditions) === null || _logicGroupInstance$c === void 0 ? void 0 : _logicGroupInstance$c.valueSeq().get(0);
  // @ts-expect-error the types are bad but optional chaining makes this safe
  const [conditionKey, condition] = (_outerCondition$condi = outerCondition === null || outerCondition === void 0 || (_outerCondition$condi2 = outerCondition.conditions) === null || _outerCondition$condi2 === void 0 ? void 0 : _outerCondition$condi2.entrySeq().get(0)) !== null && _outerCondition$condi !== void 0 ? _outerCondition$condi : [];
  return condition && conditionKey ? [condition, List.of(0, conditionKey)] : undefined;
};
export const wrapCondition = operatorInstance => {
  return operatorInstance ? Or.of(And.of(operatorInstance)) : Or.of();
};
export const usePropertyConditionChange = onChange => {
  var _unwrapCondition;
  const onPropertyFilterChange = usePropertyFilterOnChangeHandler(onChange);
  const {
    dispatch,
    internalDraftValue,
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getOperators
  } = useGetOperators();
  const {
    getValueResolver
  } = useStrategy();
  const {
    validateCondition
  } = useValidateCondition();
  const [fallbackProperty, setFallbackProperty] = useState();
  const [condition, conditionPath] = (_unwrapCondition = unwrapCondition(internalDraftValue)) !== null && _unwrapCondition !== void 0 ? _unwrapCondition : [];
  const property = condition ? condition.field : fallbackProperty;
  const onInternalValueChange = newInternalDraftValue => {
    dispatch({
      type: 'internalDraftValue',
      payload: newInternalDraftValue
    });
    onPropertyFilterChange(newInternalDraftValue);
  };
  const onConditionChange = (newCondition, shouldValidate = true) => {
    if (!newCondition) {
      onInternalValueChange(wrapCondition(undefined));
    } else {
      const validatedCondition = shouldValidate ? validateCondition(baseFilterFamily, newCondition) : newCondition.remove('errors');
      onInternalValueChange(wrapCondition(validatedCondition));
    }
  };
  const onPropertyChange = newProperty => {
    setFallbackProperty(newProperty);
    if (!condition) {
      return;
    }
    if (!newProperty) {
      onConditionChange(undefined);
      return;
    }
    const maybeNewCondition = condition.set('field', newProperty);
    const isValuePreservable = utils.getIsValuePreservable(baseFilterFamily, condition, maybeNewCondition, getOperators, getValueResolver);
    if (isValuePreservable) {
      onConditionChange(maybeNewCondition);
    } else {
      onConditionChange(undefined);
    }
  };
  return {
    condition,
    conditionPath,
    property,
    onConditionChange,
    onPropertyChange
  };
};